import { render, staticRenderFns } from "./SensorsTable.vue?vue&type=template&id=25a4430f&scoped=true"
import script from "./SensorsTable.vue?vue&type=script&lang=js"
export * from "./SensorsTable.vue?vue&type=script&lang=js"
import style0 from "./SensorsTable.vue?vue&type=style&index=0&id=25a4430f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a4430f",
  null
  
)

export default component.exports